module.exports = __webpack_public_path__ + "static/img/question-loading.59092c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/question-loading.png
// module id = eRI9
// module chunks = 6